import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customerService } from '../../../services/api';

export const useAcceptConversation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuid) => customerService.acceptConversation(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['chats'] });
    },
  });
};
